import { automaticLinkLabel, externalLinkSegments, normalizeExternalUrl, validLinkLabel } from './externalLinkText';

// Hidden destinations do not consume the visible biography budget. Bound the
// stored source separately, in sync with API utils/aboutLinks.ts.
export const ABOUT_SOURCE_MAX_BYTES = 16 * 1024;
export const ABOUT_LINK_MAX_COUNT = 10;
export const ABOUT_LINK_MAX_URL_LENGTH = 2048;

export function aboutDisplayText(value) {
  return externalLinkSegments(value).map(part => part.href ? part.customLabel || automaticLinkLabel(part.href) : part.text).join('');
}

export function aboutSourceValid(value) {
  if (new Blob([value]).size > ABOUT_SOURCE_MAX_BYTES) return false;
  const links = externalLinkSegments(value, true).filter(part => part.href);
  return links.length <= ABOUT_LINK_MAX_COUNT && links.every(part => part.href.length <= ABOUT_LINK_MAX_URL_LENGTH
    && part.rawHref.length <= ABOUT_LINK_MAX_URL_LENGTH);
}

export function bioLinkLabel(attrs) {
  return validLinkLabel(attrs.customLabel)
    || (!normalizeExternalUrl(attrs.label) && validLinkLabel(attrs.label))
    || automaticLinkLabel(attrs.href);
}

export function serializeBioLink(attrs) {
  const href = normalizeExternalUrl(attrs.href);
  const label = bioLinkLabel(attrs);
  if (!href) return attrs.label || '';
  const escaped = label.replace(/[\\[\]]/g, '\\$&');
  return `[${escaped}](${href.replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/'/g, '%27')})`;
}
